import { Box, Button, Grid, ListItemIcon, ListItemText, Menu, MenuItem, Popover, Stack, Typography } from "@mui/material";
import CustomPageHeader from "../../../global/components/CustomPageHeader/CustomPageHeader";
import EnquiryStyle from "./EnquiryStyle";
import CustomButton from "../../../global/components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import customTableStyles from "../../../global/components/CustomTable/customTable.styles";
import { store } from "../../../utils/store";
import { DataGridPro, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { ReactComponent as VerticalDotIcon } from "../../assets/icons/verticalDot.svg";
import EditIcon from "@mui/icons-material/Edit";
import urls from "../../../global/constants/UrlConstants";
import history from "../../../utils/history";
import { getEnquiry } from "./EnquiryService";
import BookingList from "../../Booking/BookingList";
const statusStyles: Record<string, any> = {
  active: {
    backgroundColor: "#E6F4EA",
    color: "#1E7F43",
  },
  cancelled: {
    backgroundColor: "#FDECEA",
    color: "#D32F2F",
  },
  rescheduled: {
    backgroundColor: "#FFF4E5",
    color: "#ED6C02",
  },
  completed: {
    backgroundColor: "#E3F2FD",
    color: "#1976D2",
  },
};

const EnquiryList = () => {
  const customTableClasses = customTableStyles;
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const privileges = store.getState().auth?.privileges || {};
  const [tableData, setTableData] = useState([])
  const [selectedMeetingId, setSelectedMeetingId] = useState<string | null>(null);

  const onClickHandler = () => {

    history.push(
      urls.createMeetingViewPath,
    );
  };

  useEffect(() => {
    handleTableData()
  }, [])

  const columns: GridColDef[] = [
     {
      headerName: "Name",
      field: "name",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
    
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
            className="action-button"
            data-action-button="true"
          >
            <Typography sx={[EnquiryStyle.headerName]}>
              {params.row?.name}

            </Typography>
       
          </Stack>
        </div>
      ),
    },
    {
      headerName: "Email",
      field: "email",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
      
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            className="action-button"
            data-action-button="true"
          >
            <Typography sx={[EnquiryStyle.feildText]}>
              {params.row?.email}
            </Typography>


          </Stack>
        </div>
      ),
    },
 {
      headerName: "Mobile Number",
      field: "phoneNumber",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
    
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
            className="action-button"
            data-action-button="true"
          >
           
            <Typography sx={[EnquiryStyle.feildText]}>
              {params.row?.phoneNumber}
</Typography>
        


          </Stack>
        </div>
      ),
    },
    {
      headerName: "Interested Service",
      field: "service",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
    
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
            className="action-button"
            data-action-button="true"
          >
            
            <Typography sx={[EnquiryStyle.feildText]}>
              {params.row?.service}
</Typography>
           


          </Stack>
        </div>
      ),
    },
 {
      headerName: "Message",
      field: "message",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
    
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
            className="action-button"
            data-action-button="true"
          >
            
            <Typography sx={[EnquiryStyle.feildText]}>
              {params.row?.message}
</Typography>
           


          </Stack>
        </div>
      ),
    },
 {
      headerName: "Page",
      field: "page",
      filterable: false,
      minWidth: 200,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          style={{ cursor: "pointer" }}
    
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            // spacing={1}
            className="action-button"
            data-action-button="true"
          >
            
            <Typography sx={[EnquiryStyle.feildText]}>
              {params.row?.page}
</Typography>
           


          </Stack>
        </div>
      ),
    },

  ];

  const renderMenu = () => (
    <Menu
      open={Boolean(menuPosition)}
      onClose={() => {
        setMenuPosition(null);
      }}
      anchorReference="anchorPosition"
      anchorPosition={
        menuPosition
          ? { top: menuPosition.top, left: menuPosition.left - 190 }
          : undefined
      }
      PaperProps={{ sx: { width: 220, maxWidth: "100%" } }}
      sx={EnquiryStyle.menuItem}
    >
      <MenuItem style={{ cursor: "default" }}>
        <ListItemText>Actions</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setMenuPosition(null);

          history.push({
            pathname: urls.createMeetingViewPath, 
            state: {
              meetingId: selectedMeetingId, 
              mode: "edit",
            },
          });
        }}
      >

        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>

        <ListItemText>Edit</ListItemText>
      </MenuItem>
 
    </Menu>
  );

  const handleTableData = async () => {
    const response = await getEnquiry()
    setTableData(response?.data)
  }
  return (
    <Box sx={EnquiryStyle.meetingWrapper}>
      <CustomPageHeader
        heading="Enquiry List"
        subInfo="Manage your enquiries here"
      />
      <Box sx={EnquiryStyle.showAllWrapper}>
        <Grid container>
          <Grid item xs={12}>
            <Grid xs={12} sx={EnquiryStyle.topPart}>
             

            </Grid>

            <Grid item xs={12} sx={customTableClasses.tableGridPart} mt={2}>

              <Box sx={customTableClasses.dataGridContainer}>

                <DataGridPro
                  columns={columns}
                  rows={tableData}
                  getRowId={(row) => row._id}
                  rowHeight={110}
                  sx={customTableClasses.gridRow}
                  getRowClassName={(params) =>
                    `${customTableClasses.tableRow}`
                  }
                  density="compact"
                  rowsLoadingMode="server"
                  // slots={{
                  //   toolbar: CustomToolbar,
                  // }}
                  localeText={{
                    noRowsLabel: "No data found",
                  }}

                />

                {renderMenu()}
              </Box>


            </Grid>


          </Grid>
        </Grid>

      </Box>
    </Box>
  )
}

export default EnquiryList;